export default {
    /**
     * Maps selected filter statuses to status ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    listFilterSelectedStatuses (state) {
        return state.appointmentList.filters.statuses.map((item) => item.id);
    },

    /**
     * Maps selected filter types to type ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    listFilterSelectedTypes (state) {
        return state.appointmentList.filters.types.map((item) => item.id);
    },

    /**
     * Maps selected filter assignees to assignee ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    listFilterSelectedAssignees (state) {
        return state.appointmentList.filters.assignees.map((item) => item.id);
    },

    /**
     * Maps selected filter report statuses to status ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    listFilterSelectedReportStatuses (state) {
        return state.appointmentList.filters.report_statuses.map((item) => item.id);
    },

    /**
     * Returns all selected filters.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    allFilterSelected (state) {
        return state.appointmentList.filters.statuses.concat(state.appointmentList.filters.types,
            state.appointmentList.filters.assignees, state.appointmentList.filters.report_statuses);
    },

    notVoidedAttachments: state => {
        return state.editAppointmentModal.data.attachments.filter(attachment => attachment.is_voided === false);
    },
};
